import { useState, useEffect } from "react";
import LazyLoad from "react-lazyload";
import PropTypes from "prop-types";
import config from "../../../config";
import LabelText from "../../atoms/label/LabelText";
import labels from "../../../config/labels";
import {
  componentCheckSize,
  checkIsOutOfStock,
  getHighlights,
  getPromotionVariant,
  showSpinner,
  hideSpinner,
  getProductImageUrl,
  getCookieValue,
} from "../../../utils/helperServices";
import {
  Row,
  Col,
  CustomContainer,
  connect,
  useRouter,
  Link,
} from "../../atoms/DependencyHelper";
import WhitePill from "../../atoms/whitePill/WhitePill";
import EmptyProductsContainer from "../emptyProductsContainer/EmptyProductsContainer";
import PageCounter from "../../atoms/pageCounter/PageCounter";
import DropDownComponent from "../../atoms/dropDown/DropDown";
import FilterNav from "../../molecules/filterNav/FilterNav";
import SortContainer from "../SortContainer/SortContainer";
import { displayHideFooter } from "../../../Redux/actions/footerAction";
import DealCard from "../../molecules/dealCard/DealCard";
import GridBanner from "../../atoms/gridBanner/GridBanner";
import UpgradeInfoBar from "../../atoms/upgradeInfoBar/upgradeInfoBar";
import styles from "./DealGridListContainer.module.scss";
import NativeSort from "../../molecules/nativeSort/NativeSort";
import { link as AnalyticsLink } from "../../../services/analyticsUtag";
import { breadcrumbGenerator } from "../../../services/breadcrumbService";
import { MOBILE_WIDTH } from "../../../config/constants";
import types from "../../../config/types";
import * as FIXED from "../../../config/constants";
import { forceVisible } from "react-lazyload";

import {
  openBreakoutUrl
} from "../../../utils/miniAppUtil";

const DealGridListContainer = (props) => {
  const env = config.env;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const PAGE_SIZE = props?.pageInfo?.page_size;
  const totalLength = props?.items?.length;
  const totalPages = props?.pageInfo?.total_pages;
  const lastItem =
    (props?.pageInfo?.current_page - 1) * props?.pageInfo?.page_size +
    totalLength;
  const router = useRouter();
  const isMobile = componentCheckSize() < MOBILE_WIDTH;
  const isTablet = componentCheckSize() <= 768;
  const lblRecommendedForYou = props?.isDealGridPage
    ? labels.sortKeys.lbl_recommended
    : labels.lbl_recommend_for_you;
  const [page, setPage] = useState(props?.pageInfo?.current_page || 1);

  useEffect(() => {
    props.displayHideFooter(props.hide);
  }, []);

  useEffect(() => {
    setPage(props?.pageInfo?.current_page);
    setTimeout(forceVisible, 1000);
  }, [props?.pageInfo]);

  function getSortParams() {
    const dropdownValues = [
      { label: lblRecommendedForYou },
      { label: labels.sortKeys.lbl_most_popular },
      { label: labels.sortKeys.lbl_low_to_high },
      { label: labels.sortKeys.lbl_high_to_low },
    ];
    return dropdownValues;
  }
  const dealSortValues = getSortParams();

  const handleSelected = (value) => {
    props?.sortBy(true, value);
  };

  const handleSelectedMobile = (flag, value = "") => {
    props?.sortBy(flag, flag ? value : lblRecommendedForYou);
  };

  const increasePageCount = () => {
    if (page < totalPages) {
      props?.updateCurrentPage(page + 1);
      setPage(page + 1);
      if (props?.isDealGridPage) {
        window.scrollTo(0, 0);
      }
      if (props.pageName == "upgrade") {
        if (isMobile) {
          window.scrollTo(0, 100);
        } else {
          window.scrollTo(0, 600);
        }
      }
    }
  };

  const decreasePageCount = () => {
    if (page > 1) {
      props?.updateCurrentPage(page - 1);
      setPage(page - 1);
      if (props?.isDealGridPage) {
        window.scrollTo(0, 0);
      }
      if (props.pageName == "upgrade") {
        if (isMobile) {
          window.scrollTo(0, 100);
        } else {
          window.scrollTo(0, 600);
        }
      }
    }
  };

  const handleCurrentPageChange = (page) => {
    props?.updateCurrentPage(page);
    setPage(page);
    if (props?.isDealGridPage) {
      window.scrollTo(0, 0);
    }
  };

  const FilterText =
    props?.items?.length > 0
      ? `${(props?.pageInfo?.current_page - 1) * PAGE_SIZE + 1} - ${lastItem} of
	${props?.totalItemsCount} ${
          props.pageName == "upgrade" && isMobile ? "" : "results"
        }`
      : "Showing 0 of 0 results";

  const onSeeDetailsClick = (item) => {
    let contracts = item.contract_sku;
    if (!Array.isArray(contracts)) {
      contracts = [`${contracts}`];
    } else {
      const total = contracts.length;
      const contractPosition = contracts.indexOf(item.sku);
      if (contractPosition !== -1 && contractPosition !== total - 1) {
        const filteredContracts = contracts.filter(
          (contract) => contract !== item.sku
        );
        filteredContracts.push(item.sku);
        contracts = filteredContracts;
      }
    }
    showSpinner();
    router
      .push({
        pathname: `${urlPrefix}/deal-details-page/${item.url_key}`,
        query: props?.buyOption
          ? {
              buyOption: props?.defaultUpgrade ? "upgrade" : props?.buyOption,
            }
          : props?.defaultUpgrade
          ? { buyOption: "upgrade" }
          : null,
      })
      .then(() => {
        window.scrollTo(0, 0);
        hideSpinner();
      });
    return props?.onSeeDetailsClick && props.onSeeDetailsClick(item);
  };

  const breadcrumbs = breadcrumbGenerator().deals.reverse();
  const section_lvls = {};
  let index = 0;
  for (let item of breadcrumbs) {
    index = index + 1;
    if (index > 4) break;
    section_lvls[`page_site_section_lvl_${index}`] = item.label;
  }
  const resetFilterHandler = () => {
    props?.clearCategories();
    props.onFilterReset();
    if (isMobile) {
      AnalyticsLink({
        page_name: "shopping: deals grid: browse all deals",
        page_channel: "shopping",
        page_tool_event: "use",
        page_tool_name:
          "shopping: deals grid: browse all deals: reset all filters",
        page_master_tab: "personal",
        ...section_lvls,
      });
    }
  };

  const handleRedirect = () => {

    showSpinner();

    const url = props?.bannerData[0]?.banner_url;

    if (!url) {
      return;
    }

    const isMiniApp = getCookieValue("miniApp") === "true";

    if (isMiniApp) {

      openBreakoutUrl(url);
      return;
    }

    window.location = `${url}`;
  };

  const truncateString = (str, stringLen) => {
    return str.length > stringLen ? str.substring(0, stringLen) + "..." : str;
  };

  return props.hide && props?.featureSelected === "sort" ? (
    <div className={styles["sort-gutter"]}>
      <FilterNav
        headingName="Sort by"
        backbtn={props?.show}
        resetClickHandler={() => handleSelectedMobile()}
      />
      {dealSortValues.map((sortLabel, index) => (
        <SortContainer
          key={`sort_order_${index}`}
          close={props?.show}
          boxHeading={sortLabel.label}
          selected={props?.selectedSortVal === sortLabel.label}
          selectHandler={(flag) => handleSelectedMobile(flag, sortLabel.label)}
        />
      ))}
    </div>
  ) : (
    !props.hide && (
      <CustomContainer>
        <Row
          className={`${!props?.bannerData?.length && "mb-s"} ${
            props?.isDealSelection ? styles["sort-deal-selection"] : ""
          } ${props.pageName == "upgrade" ? styles["upgrade-row"] : ""}`}
        >
          <Col xs={12}>
            <div className="d-flex mb-2">
              {props?.showUpgradeInfoBar && isMobile && (
                <CustomContainer className={styles["info-banner"]}>
                  <UpgradeInfoBar
                    type="info"
                    message={labels.lbl_upgrade_info_banner}
                  />
                </CustomContainer>
              )}
              {(!isTablet || isMobile) && (
                <LabelText
                  className={`${styles["page-info"]} ${
                    styles["page-info-text"]
                  }  ${
                    props.isDealSelection ? styles["page-info-text-btm"] : ""
                  } d-inline-flex align-items-center ml-0 pl-0 ${
                    props.pageName == "upgrade"
                      ? styles["upgrade-page-info"]
                      : ""
                  }`}
                >
                  {FilterText}
                </LabelText>
              )}
              {isTablet && !isMobile && (
                <CustomContainer className={`${styles.pillsDiv} pl-0 w-100`}>
                  <LabelText
                    className={`${styles["page-info"]} ${
                      styles["page-info-text"]
                    }  ${
                      props.isDealSelection ? styles["page-info-text-btm"] : ""
                    } d-inline-flex align-items-center ml-0 pl-0 ${
                      props.pageName == "upgrade"
                        ? styles["upgrade-page-info"]
                        : ""
                    }`}
                  >
                    {FilterText}
                  </LabelText>
                  {props?.selectedPrice &&
                    !(
                      Number(props?.selectedPrice?.minValue).toFixed() == 0 &&
                      props?.selectedPrice?.maxValue == props.originalMax
                    ) && (
                      <WhitePill
                        className={styles.pillSpacing}
                        style={{ marginRight: "8px" }}
                        name={`R${props?.selectedPrice?.minValue} PM - R${props?.selectedPrice?.maxValue} PM`}
                        removeBtnHandler={() => props?.onPriceChange()}
                      />
                    )}
                  {props?.selectedBrands?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_brand_${item.label}`}
                      name={item.label}
                      removeBtnHandler={() => props?.onBrandChange(false, item)}
                    />
                  ))}
                  {props?.selectedProducts?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_product_${item.value}`}
                      name={truncateString(item.label, 25)}
                      removeBtnHandler={() =>
                        props?.onProductFilterChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedPromotions?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_promotion_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onPromotionChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedPlantype?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_plan_type_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onPlanTypeChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedPromoData &&
                    !(
                      Number(props?.selectedPromoData[0]?.label).toFixed() ==
                        0 &&
                      props?.selectedPromoData[1]?.label == FIXED.MAX_DATA
                    ) && (
                      <WhitePill
                        className={styles.pillSpacing}
                        style={{ marginRight: "8px" }}
                        name={`${props?.selectedPromoData[0]?.label}GB - ${props?.selectedPromoData[1]?.label}GB`}
                        removeBtnHandler={() => props?.onDataChange()}
                      />
                    )}
                  {props?.selectedMinutesData &&
                    !(
                      Number(props?.selectedMinutesData[0]?.label).toFixed() ==
                        0 &&
                      props?.selectedMinutesData[1]?.label == FIXED.MAX_MINUTES
                    ) && (
                      <WhitePill
                        className={styles.pillSpacing}
                        style={{ marginRight: "8px" }}
                        name={`${props?.selectedMinutesData[0]?.label} min - ${
                          props?.selectedMinutesData[1]?.label ==
                          FIXED.MAX_MINUTES
                            ? `Unlimited`
                            : `${props?.selectedMinutesData[1]?.label} min`
                        }`}
                        removeBtnHandler={() => props?.onMinutesChange()}
                      />
                    )}
                  {props?.selectedAirtimeData &&
                    !(
                      Number(props?.selectedAirtimeData[0]?.label).toFixed() ==
                        0 &&
                      props?.selectedAirtimeData[1]?.label == FIXED.MAX_AIRTIME
                    ) && (
                      <WhitePill
                        className={styles.pillSpacing}
                        style={{ marginRight: "8px" }}
                        name={`R${props?.selectedAirtimeData[0]?.label} - R${props?.selectedAirtimeData[1]?.label}`}
                        removeBtnHandler={() => props?.onAirtimeChange()}
                      />
                    )}
                  {props?.selectedPlanname?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_plan_name_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onPlanNameChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedAcccessories?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_accessories_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onAccessoriesChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedContractDuration?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_contract_duration_${item.sku}`}
                      name={`${item.label} months`}
                      removeBtnHandler={() =>
                        props?.onContractDurationChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedContractType?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_contract_type_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onContractTypeChange(false, item)
                      }
                    />
                  ))}
                </CustomContainer>
              )}
              {!isMobile && !isTablet && (
                <CustomContainer
                  className={`${
                    props.pageName != "upgrade"
                      ? styles["price-switch"]
                      : "upgrade-dropdown"
                  } ${
                    !isMobile ? "product-list-container deal-sort-dropdown" : ""
                  } ${props.pageName == "upgrade" ? styles["disabled"] : ""}`}
                >
                  <LabelText className={styles["page-info-text"]}>
                    Sort by:
                  </LabelText>
                  <DropDownComponent
                    data={dealSortValues}
                    handleSelect={handleSelected}
                    selectedValue={props?.selectedSortVal}
                    customClass={
                      props.page == "deal-list"
                        ? styles["dropdown-item"]
                        : styles["selection-drop-down"]
                    }
                    menuClassName="sort-menu"
                    id="deal-sort-menu"
                  />
                </CustomContainer>
              )}
              {(isMobile || isTablet) && (
                <CustomContainer
                  className={`${styles["deal-sort-native-container-class"]} ${
                    props.pageName == "upgrade" ? styles["disabled"] : ""
                  }`}
                >
                  <NativeSort
                    sortOptions={dealSortValues}
                    handleSelect={handleSelected}
                    selectedValue={props?.selectedSortVal}
                    id="deal-sort-menu-native"
                  />
                </CustomContainer>
              )}
            </div>
            {(!isTablet || isMobile) && (
              <div className="d-flex">
                <CustomContainer className={`${styles.pillsDiv} pl-0 w-100`}>
                  {props?.selectedPrice &&
                    !(
                      Number(props?.selectedPrice?.minValue).toFixed() == 0 &&
                      props?.selectedPrice?.maxValue == props.originalMax
                    ) && (
                      <WhitePill
                        className={styles.pillSpacing}
                        style={{ marginRight: "8px" }}
                        name={`R${props?.selectedPrice?.minValue} PM - R${props?.selectedPrice?.maxValue} PM`}
                        removeBtnHandler={() => props?.onPriceChange()}
                      />
                    )}
                  {props?.selectedBrands?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_brand_${item.label}`}
                      name={item.label}
                      removeBtnHandler={() => props?.onBrandChange(false, item)}
                    />
                  ))}
                  {props?.selectedProducts?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_product_${item.value}`}
                      name={truncateString(item.label, 25)}
                      removeBtnHandler={() =>
                        props?.onProductFilterChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedPromotions?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_promotion_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onPromotionChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedPlantype?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_plan_type_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onPlanTypeChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedPromoData &&
                    !(
                      Number(props?.selectedPromoData[0]?.label).toFixed() ==
                        0 &&
                      props?.selectedPromoData[1]?.label == FIXED.MAX_DATA
                    ) && (
                      <WhitePill
                        className={styles.pillSpacing}
                        style={{ marginRight: "8px" }}
                        name={`${props?.selectedPromoData[0]?.label}GB - ${props?.selectedPromoData[1]?.label}GB`}
                        removeBtnHandler={() => props?.onDataChange()}
                      />
                    )}
                  {props?.selectedMinutesData &&
                    !(
                      Number(props?.selectedMinutesData[0]?.label).toFixed() ==
                        0 &&
                      props?.selectedMinutesData[1]?.label == FIXED.MAX_MINUTES
                    ) && (
                      <WhitePill
                        className={styles.pillSpacing}
                        style={{ marginRight: "8px" }}
                        name={`${props?.selectedMinutesData[0]?.label} min - ${
                          props?.selectedMinutesData[1]?.label ==
                          FIXED.MAX_MINUTES
                            ? `Unlimited`
                            : `${props?.selectedMinutesData[1]?.label} min`
                        }`}
                        removeBtnHandler={() => props?.onMinutesChange()}
                      />
                    )}
                  {props?.selectedAirtimeData &&
                    !(
                      Number(props?.selectedAirtimeData[0]?.label).toFixed() ==
                        0 &&
                      props?.selectedAirtimeData[1]?.label == FIXED.MAX_AIRTIME
                    ) && (
                      <WhitePill
                        className={styles.pillSpacing}
                        style={{ marginRight: "8px" }}
                        name={`R${props?.selectedAirtimeData[0]?.label} - R${props?.selectedAirtimeData[1]?.label}`}
                        removeBtnHandler={() => props?.onAirtimeChange()}
                      />
                    )}
                  {props?.selectedPlanname?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_plan_name_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onPlanNameChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedAcccessories?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_accessories_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onAccessoriesChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedContractDuration?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_contract_duration_${item.sku}`}
                      name={`${item.label} months`}
                      removeBtnHandler={() =>
                        props?.onContractDurationChange(false, item)
                      }
                    />
                  ))}
                  {props?.selectedContractType?.map((item) => (
                    <WhitePill
                      className={styles.pillSpacing}
                      style={{ marginRight: "8px" }}
                      key={`selected_contract_type_${item.sku}`}
                      name={item.label}
                      removeBtnHandler={() =>
                        props?.onContractTypeChange(false, item)
                      }
                    />
                  ))}
                </CustomContainer>
              </div>
            )}
          </Col>
        </Row>

        {props?.showUpgradeInfoBar && !isMobile && (
          <CustomContainer className={styles["info-banner"]}>
            <UpgradeInfoBar
              type="info"
              message={labels.lbl_upgrade_info_banner}
            />
          </CustomContainer>
        )}

        {props?.items && props?.items?.length ? (
          <Row
            className={
              !props.isDealSelection ? "custom-grid-gutter mx-0" : "mx-0"
            }
          >
            {props?.bannerData && props?.bannerData?.length > 0 && (
              <Col md={12} className={`${styles["banner"]}`}>
                <GridBanner
                  bannerData={props?.bannerData}
                  redirectTo={handleRedirect}
                />
              </Col>
            )}

            {props.items.map((item) => (
              <Col
                key={item.sku}
                sm={6}
                md={props.pageName == "upgrade" ? 6 : 4}
                lg={4}
                xl={props.spanXl}
                className={
                  props.isDealSelection
                    ? styles["deal-cards-custom-spacing"]
                    : ""
                }
              >
                <Link legacyBehavior
                  href={{
                    pathname: `${urlPrefix}/deal-details-page/${item.url_key}`
                  }}
                >
                  <a className={styles["dealcard-link"]}>
                    <LazyLoad>
                      <DealCard
                        width={isMobile ? "14.12rem" : "auto"}
                        height="32.938rem"
                        img_width="10rem"
                        maxHeight="33.5rem"
                        img_height="10rem"
                        width_mobile="100%"
                        height_mobile="29.313rem"
                        img_width_mobile="7.5rem"
                        img_height_mobile="7.5rem"
                        productName={item.name}
                        imgUrl={getProductImageUrl(item, "image", "No_image")}
                        imgUrl_mobile={getProductImageUrl(
                          item,
                          "small_image",
                          "No_image_1"
                        )}
                        isOutOfStock={checkIsOutOfStock(item)}
                        saveLabel={item?.save_monthly_recurring}
                        promotionLabel={item?.promotion_tag != null && item.promotion_tag_label ? item?.promotion_tag_label : ''}
                        promotionLabelColor={item.promotion_tag_swatch}
                        promotionVariant={getPromotionVariant(item)}
                        planName={
                          item.package_description
                            ? item.package_description
                            : ""
                        }
                        highlights={getHighlights(item)}
                        originalPrice={
                          item.monthly_recurring ? item.monthly_recurring : ""
                        }
                        offerPrice={
                          item.monthly_recurring ? item.monthly_recurring : ""
                        }
                        prevPrice={item.old_monthly_recurring ? item.old_monthly_recurring : ""}
                        numberOfMonths={item.payment_terms_label}
                        buttonText={
                          item.promotion_tag_label == types.TYPE_PREORDER
                            ? labels.lbl_preorder_now
                            : !props?.isDealSelection
                            ? labels.lbl_see_details
                            : labels.lbl_deal_selection_page_card_btn
                        }
                        buttonHandler={() => onSeeDetailsClick(item)}
                        deal_end_date={item.deal_end_date}
                        deal_go_live_date={item.deal_go_live_date}
                        deal_label={item.deal_label}
                        is_deal_locked={item.is_deal_locked}
                        className="deal-list-items"
                        campaignFlag={false}
                      />
                    </LazyLoad>
                  </a>
                </Link>
              </Col>
            ))}
          </Row>
        ) : (
          <Row
            className={`${styles["containerheight"]} custom-grid-empty-gutter`}
          >
            <Col>
              <EmptyProductsContainer
                resetFilter={resetFilterHandler}
                message={
                  props.showQualifyDeals
                    ? labels.upgrade.lbl_deals_no_products
                    : null
                }
                ctaHidden={props.showQualifyDeals}
              />
            </Col>
          </Row>
        )}

        {totalPages > 0 && (
          <PageCounter
            pageNumber={props?.pageInfo?.current_page}
            totalPages={totalPages}
            increasePageCount={increasePageCount}
            decreasePageCount={decreasePageCount}
            handleCurrentPageChange={(cPage) => handleCurrentPageChange(cPage)}
            className={!isMobile ? "grid-pagination" : ""}
          />
        )}
      </CustomContainer>
    )
  );
};

DealGridListContainer.propTypes = {
  displayHideFooter: PropTypes.func,
  defaultUpgrade: PropTypes.bool,
  hide: PropTypes.bool,
  items: PropTypes.array,
  onAccessoriesChange: PropTypes.func,
  onAirtimeChange: PropTypes.func,
  onBrandChange: PropTypes.func,
  onContractTypeChange: PropTypes.func,
  onContractDurationChange: PropTypes.func,
  onDataChange: PropTypes.func,
  onFilterReset: PropTypes.func,
  onMinutesChange: PropTypes.func,
  onPlanNameChange: PropTypes.func,
  onPlanTypeChange: PropTypes.func,
  onPriceChange: PropTypes.func,
  onProductFilterChange: PropTypes.func,
  onPromotionChange: PropTypes.func,
  onSeeDetailsClick: PropTypes.func,
  pageName: PropTypes.string,
  selectedbrands: PropTypes.array,
  showQualifyDeals: PropTypes.bool,
  showUpgradeInfoBar: PropTypes.bool,
  spanXl: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  pageInfo: PropTypes.object,
  isDealGridPage: PropTypes.bool,
  buyOption: PropTypes.string,
  sortBy: PropTypes.func,
  updateCurrentPage: PropTypes.func,
  totalItemsCount: PropTypes.number,
  clearCategories: PropTypes.func,
  bannerData: PropTypes.arrayOf(PropTypes.object),
  featureSelected: PropTypes.string,
  show: PropTypes.func,
  selectedSortVal: PropTypes.string,
  isDealSelection: PropTypes.bool,
  selectedPrice: PropTypes.object,
  originalMax: PropTypes.number,
  selectedBrands: PropTypes.arrayOf(PropTypes.object),
  selectedProducts: PropTypes.arrayOf(PropTypes.object),
  selectedPromotions: PropTypes.arrayOf(PropTypes.object),
  selectedPlantype: PropTypes.arrayOf(PropTypes.object),
  selectedPromoData: PropTypes.arrayOf(PropTypes.object),
  selectedMinutesData: PropTypes.arrayOf(PropTypes.object),
  selectedAirtimeData: PropTypes.arrayOf(PropTypes.object),
  selectedPlanname: PropTypes.arrayOf(PropTypes.object),
  selectedAcccessories: PropTypes.arrayOf(PropTypes.object),
  selectedContractDuration: PropTypes.arrayOf(PropTypes.object),
  selectedContractType: PropTypes.arrayOf(PropTypes.object),
  page: PropTypes.string,
};

DealGridListContainer.defaultProps = {
  showUpgradeInfoBar: false,
};

export default connect(null, {
  displayHideFooter,
})(DealGridListContainer);
